import { render, staticRenderFns } from "./kyc-account-details.vue?vue&type=template&id=4d2b6d26&scoped=true"
import script from "./kyc-account-details.vue?vue&type=script&lang=js"
export * from "./kyc-account-details.vue?vue&type=script&lang=js"
import style0 from "./kyc-account-details.vue?vue&type=style&index=0&id=4d2b6d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2b6d26",
  null
  
)

export default component.exports